import sessionApi from './apiClient';

export interface ReferenceOption {
  value: string;
  label: string;
}

export interface ReferenceData {
  version: string;
  roles: ReferenceOption[];
  firearm_types: ReferenceOption[];
  firearm_conditions: ReferenceOption[];
  firearm_statuses: ReferenceOption[];
  issuance_statuses: ReferenceOption[];
  are_statuses: ReferenceOption[];
  ltopf_statuses: ReferenceOption[];
  return_statuses: ReferenceOption[];
  return_reasons: ReferenceOption[];
  incident_classifications: ReferenceOption[];
  incident_statuses: ReferenceOption[];
  inspection_statuses: ReferenceOption[];
  validation_results: ReferenceOption[];
  notification_types: ReferenceOption[];
  notification_statuses: ReferenceOption[];
  audit_actions: ReferenceOption[];
  audit_modules: ReferenceOption[];
  audit_results: ReferenceOption[];
  security_event_types: ReferenceOption[];
  archive_statuses: ReferenceOption[];
  report_types: ReferenceOption[];
}

export const referenceDataService = {
  load: async (): Promise<ReferenceData> => {
    const response = await sessionApi.get<ReferenceData>('/reference-data/');
    return response.data;
  },
};

